import React from 'react';

import FormRecurringMeetingsSelection from 'Shared/components/FormComponents/FormRecurringMeetingsSelection';
import { WorkspaceType } from 'Shared/constants/types';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function CreateGroupWorkspacesFormFields() {
  const { tr } = useTranslation();

  return (
    <div className="CreateGroupWorkspacesFormFields d-flex flex-column">
      <div className="mb-4">{tr('perform.sync_meetings.group.header', 'group meetings')}</div>
      <FormRecurringMeetingsSelection
        selector="recurringMeetings"
        type={WorkspaceType.isGroup}
        label={tr('perform.sync_meetings.group.label_calendar_group')}
      />
    </div>
  );
}

export default CreateGroupWorkspacesFormFields;
